import { useState } from "react";
import { useAuthContext } from "./useauthContext";
import axios from "axios";
import { API_URL } from "../config";
import { loadStripe } from '@stripe/stripe-js';
import { getUserId } from "../Context/auth";

const stripePromise = loadStripe("pk_live_51QzMcP054Qyo0MBEe9mP6WgEgYeZYHtOuTc1pJjEgM80zxQBoY5nOF73uebH4g7AdTELDpKsUsD1owyLYKzxvrLd00oUGkNvot");

export const usePayment = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const payment = async (userId, plan) => {
        setIsLoading(true);
        setError(null);
        try {
          // Save pending signup details for use after payment
          
          // Create a Stripe Checkout session on the backend
          const sessionResponse = await axios.post(`${API_URL}/create-checkout-session`, { plan, userId });
          const { sessionId } = sessionResponse.data;
          
          // Redirect to Stripe Checkout
          const stripe = await stripePromise;
          const { error: stripeError } = await stripe.redirectToCheckout({ sessionId });
          if (stripeError) {
            setIsLoading(false);
            setError(stripeError.message);
            return null;
          }
          
          // The user will be redirected by Stripe.
          setIsLoading(false);
          return null;
        } catch (err) {
          setIsLoading(false);
          setError(err.response?.data?.detail || "Payment Failed");
          return null;
        }
      };

      return { payment, isLoading, error };
}